const uniqueItemInArray = [
  'unique',
];
module.exports = {
  uniqueItemInArray,
};
